var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargingReportsUiInvoice2Medium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,10h-3v2h3c1.6542969,0,3,1.3457031,3,3v26c0,1.6542969-1.3457031,3-3,3H21c-1.6542969,0-3-1.3457031-3-3v-3h-2v3 c0,2.7568359,2.2431641,5,5,5h16c2.7568359,0,5-2.2431641,5-5V15C42,12.2431641,39.7568359,10,37,10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,31V7c0-2.7568359-2.2431641-5-5-5H11C8.2431641,2,6,4.2431641,6,7v24c0,2.7568359,2.2431641,5,5,5h16 C29.7568359,36,32,33.7568359,32,31z M8,31V7c0-1.6542969,1.3457031-3,3-3h16c1.6542969,0,3,1.3457031,3,3v24 c0,1.6542969-1.3457031,3-3,3H11C9.3457031,34,8,32.6542969,8,31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8486328,18h-5.6972656C16.0683594,18,16,17.9316406,16.0253906,17.7646484l4.8066406-7.2099609l-1.6640625-1.109375 L14.3603516,16.65625C14.125,17.0107422,14,17.4238281,14,17.8486328C14,19.0351562,14.9648438,20,16.1513672,20h5.6972656 C21.9316406,20,22,20.0683594,21.9746094,20.2353516l-4.8066406,7.2099609l1.6640625,1.109375l4.8076172-7.2109375 C23.875,20.9892578,24,20.5761719,24,20.1513672C24,18.9648438,23.0351562,18,21.8486328,18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingReportsUiInvoice2Medium);
export default __webpack_public_path__ + "static/media/charging-reports-ui-invoice-2--medium.edb21a3691338a551c2858e4cb020868.svg";
export { ForwardRef as ReactComponent };